export const translations = {
  ro: {
    auth: {
      title: "Autentificare",
      username: "Utilizator",
      password: "Parola",
      login: "Conectare"
    },
    title: "Analize Sange",
    nav: {
      overview: "Prezentare",
      trends: "Tendinte",
      reference: "Referinta",
      table: "Tabel",
      testData: "Test"
    },
    overview: {
      title: "Ultimele Rezultate",
      subtitle: "Rezumat valori CBC din ultima analiza"
    },
    trends: {
      title: "Tendinte in Timp",
      subtitle: "Evolutia valorilor pe parcursul analizelor",
      rbc: "Eritrocite",
      wbc: "Leucocite",
      platelets: "Trombocite",
      hemoglobin: "Hemoglobina",
      all: "Toate",
      viewType: "Tip vizualizare:",
      grid: "Grid",
      radar: "Radar",
      multiaxis: "Multi-axe",
      insufficientData: "Date insuficiente pentru grafic. Este necesara cel putin o analiza cu date disponibile."
    },
    reference: {
      title: "Comparatie cu Referinta",
      subtitle: "Valori comparate cu intervalul de referinta",
      selectDate: "Selecteaza data:"
    },
    table: {
      title: "Date Complete",
      subtitle: "Toate valorile din analize",
      low: "Sub referinta",
      normal: "Normal",
      high: "Peste referinta",
      test: "Test",
      unit: "Unitate",
      reference: "Referinta"
    },
    footer: {
      disclaimer: "Acest dashboard este doar pentru uz informativ. Consultati un medic pentru interpretare."
    },
    tests: {
      // CBC tests
      rbc: "Hematii (RBC)",
      hemoglobin: "Hemoglobina",
      hematocrit: "Hematocrit",
      mcv: "VCM",
      mch: "HEM",
      mchc: "CHEM",
      rdw: "RDW",
      platelets: "Trombocite",
      wbc: "Leucocite",
      mpv: "MPV",
      pdw: "PDW",
      // Differential
      neutrophils: "Neutrofile",
      lymphocytes: "Limfocite",
      monocytes: "Monocite",
      eosinophils: "Eozinofile",
      basophils: "Bazofile",
      // BIO tests
      alt: "ALT",
      ast: "AST",
      bilirubin: "Bilirubina Totala",
      calcium: "Calciu Seric",
      alp: "Fosfataza Alcalina",
      ggt: "GGT",
      magnesium: "Magneziu Seric",
      potassium: "Potasiu Seric",
      sodium: "Sodiu Seric",
      uric_acid: "Acid Uric Seric",
      creatinine: "Creatinina Serica"
    },
    admin: {
      title: "Gestionare Utilizatori",
      addUser: "Adauga Utilizator",
      userList: "Utilizatori",
      username: "Utilizator",
      password: "Parola",
      passwordHint: "Minim 6 caractere",
      newPassword: "Parola Noua (lasa gol pentru a pastra actuala)",
      role: "Rol",
      created: "Creat",
      actions: "Actiuni",
      add: "Adauga",
      save: "Salveaza",
      cancel: "Anuleaza",
      editUser: "Editeaza Utilizator"
    }
  },
  en: {
    auth: {
      title: "Login",
      username: "Username",
      password: "Password",
      login: "Sign In"
    },
    title: "Blood Tests",
    nav: {
      overview: "Overview",
      trends: "Trends",
      reference: "Reference",
      table: "Table",
      testData: "Test"
    },
    overview: {
      title: "Latest Results",
      subtitle: "CBC values summary from latest analysis"
    },
    trends: {
      title: "Trends Over Time",
      subtitle: "Value changes across analyses",
      rbc: "Red Blood Cells",
      wbc: "White Blood Cells",
      platelets: "Platelets",
      hemoglobin: "Hemoglobin",
      all: "All",
      viewType: "View type:",
      grid: "Grid",
      radar: "Radar",
      multiaxis: "Multi-axis",
      insufficientData: "Insufficient data for chart. At least one analysis with available data is required."
    },
    reference: {
      title: "Reference Comparison",
      subtitle: "Values compared to reference ranges",
      selectDate: "Select date:"
    },
    table: {
      title: "Complete Data",
      subtitle: "All values from analyses",
      low: "Below reference",
      normal: "Normal",
      high: "Above reference",
      test: "Test",
      unit: "Unit",
      reference: "Reference"
    },
    footer: {
      disclaimer: "This dashboard is for informational purposes only. Consult a doctor for interpretation."
    },
    tests: {
      // CBC tests
      rbc: "RBC",
      hemoglobin: "Hemoglobin",
      hematocrit: "Hematocrit",
      mcv: "MCV",
      mch: "MCH",
      mchc: "MCHC",
      rdw: "RDW",
      platelets: "Platelets",
      wbc: "WBC",
      mpv: "MPV",
      pdw: "PDW",
      // Differential
      neutrophils: "Neutrophils",
      lymphocytes: "Lymphocytes",
      monocytes: "Monocytes",
      eosinophils: "Eosinophils",
      basophils: "Basophils",
      // BIO tests
      alt: "ALT",
      ast: "AST",
      bilirubin: "Total Bilirubin",
      calcium: "Calcium",
      alp: "Alkaline Phosphatase",
      ggt: "GGT",
      magnesium: "Magnesium",
      potassium: "Potassium",
      sodium: "Sodium",
      uric_acid: "Uric Acid",
      creatinine: "Creatinine"
    },
    admin: {
      title: "User Management",
      addUser: "Add New User",
      userList: "Users",
      username: "Username",
      password: "Password",
      passwordHint: "Min 6 characters",
      newPassword: "New Password (leave empty to keep current)",
      role: "Role",
      created: "Created",
      actions: "Actions",
      add: "Add",
      save: "Save",
      cancel: "Cancel",
      editUser: "Edit User"
    }
  }
};

let currentLang = localStorage.getItem('lang') || 'ro';

export function t(key) {
  const keys = key.split('.');
  let value = translations[currentLang];
  for (const k of keys) {
    value = value?.[k];
  }
  return value || key;
}

export function getLang() {
  return currentLang;
}

export function setLang(lang) {
  currentLang = lang;
  localStorage.setItem('lang', lang);
  updatePageTranslations();
}

export function toggleLang() {
  setLang(currentLang === 'ro' ? 'en' : 'ro');
  return currentLang;
}

export function updatePageTranslations() {
  document.querySelectorAll('[data-i18n]').forEach(el => {
    const key = el.getAttribute('data-i18n');
    el.textContent = t(key);
  });
}
